/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=405e7c1b"
const script = {}

import exportComponent from "D:\\noui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__